import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clear, ClearCartError } from '../../actions/cart';
import { ReloadHotels } from '../../actions/hotels';
import { ReloadPackages } from '../../actions/packages';
import {
    CreateCartErrorDialog,
} from '../../components/dialogs/CreateCartErrorDialog';

import {
    ItemRanOutOfStockDialog,
} from '../../components/dialogs/ItemRanOutOfStockDialog';

import { FullScreenLoader } from '../../components/FullScreenLoader';
import { useFramePositioning } from '../../hooks/useFramePositioning.js';
import { usePreloadMedia } from '../../hooks/usePreloadMedia.js';

import isCheckoutPage from '../../utils/is-checkout-page';
import { getThemeFileUri, translate } from '../../utils/wp.js';
import {
    CartExpirationController,
} from './controllers/CartExpirationController.js';

import StockController from './controllers/stock-controller';

function ApplicationBridge() {
    const [isOutOfStock, setIsOutOfStock] = useState(false);
    const [hasTickets, setHasTickets] = useState(false);
    const [hasHotels, setHasHotels] = useState(false);

    const stockCheckEnabled = useSelector(state => state.app.stock_check_enabled);
    const loadingCart = useSelector(state => state.cart.loading_cart);
    const loadingEmptyCart = useSelector(state => state.cart.loading_empty_cart);
    const createCartError = useSelector(state => state.cart.create_cart_error);
    const eventUrl = useSelector(state => state.cart.event_url);

    const dispatch = useDispatch();

    usePreloadMedia(getThemeFileUri('static/images/loader.webm'));

    useFramePositioning();

    function onStockCheckFailure(hasTickets, hasHotels) {
        setIsOutOfStock(true);
        setHasTickets(hasTickets);
        setHasHotels(hasHotels);
    }

    async function onClickOutOfStockDialog() {
        if (document.location.href !== eventUrl) {
            await dispatch(clear());

            localStorage.removeItem('persist:cart');
            if (eventUrl != null) {
                document.location.href = eventUrl;
            } else {
                if (isCheckoutPage()) {
                    document.location.href = '/';
                } else {
                    document.location.reload();
                }
            }
        } else {
            if (hasTickets) {
                onResetHotels();
            } else {
                onResetTickets();
            }
        }
    }

    async function onClickCartErrorDialog() {
        dispatch(ClearCartError());
    }

    function onResetHotels() {
        dispatch(ReloadHotels());

        setIsOutOfStock(false);
    }

    function onResetTickets() {
        dispatch(ReloadPackages());

        setIsOutOfStock(false);
    }

    return (
        <>
            <StockController
                active={stockCheckEnabled && !isOutOfStock}
                onFailure={onStockCheckFailure}
            />
            <ItemRanOutOfStockDialog
                visible={isOutOfStock}
                hasTickets={hasTickets}
                hasHotels={hasHotels}
                onClick={onClickOutOfStockDialog}
            />
            <CreateCartErrorDialog
                visible={createCartError != null}
                type={createCartError != null ? createCartError.type : null}
                onDismiss={onClickCartErrorDialog}
            />
            <CartExpirationController />
            <FullScreenLoader
                visible={loadingCart}
                message={translate('loading_checkout_message')}
            />
            <FullScreenLoader
                visible={loadingEmptyCart}
                message={translate('empty_cart_message')}
            />
        </>
    );
}

export default ApplicationBridge;
